import React, { Component } from 'react';
import firebase from 'firebase';
import { browserHistory } from 'react-router';
import { Row, Column as Col } from 'hedron';

class Login extends Component {

  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
    };

    this.login = this.login.bind(this);
  }

  login(e) {
    e.preventDefault();
    const { email, password } = this.state;
    firebase.auth().signInWithEmailAndPassword(email, password)
    .then(function() {
      browserHistory.push('/customers');
    })
    .catch(function(error) {

      alert(error.message);
    });
  }

  render() {

    return (
      <div>
        <Row>
          <Col className="pt-card" sm={4} smShift={4}>
            <h3>Login</h3>
            <form onSubmit={this.login}>
              <input
                className="pt-input"
                placeholder="E-Mail"
                value={this.state.email}
                onChange={(e)=>this.setState({ email: e.target.value })}
                type="email" />
              <input
                className="pt-input"
                placeholder="Passwort"
                value={this.state.password}
                onChange={(e)=>this.setState({ password: e.target.value })}
                type="password" />
              <button
                className="pt-button pt-intent-primary"
                value="Login"
                type="submit">
                Login
              </button>
            </form>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Login;



/** WEBPACK FOOTER **
 ** ./src/Login.js
 **/